const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`, `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`, 1, 34), new Map([[`tag_name`, `label`], [`inner_tag_name`, `span`]]), false, false, 1));
            }

            getTemplateName() {
                return `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`, ``);
            }
        }],
        [34, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`, 1);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/checkbox/checkbox.twig`, new Map([[`class`, `o-media__object`]]), true, false, 6));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    Notify me of follow-up comments by email.
  `);
            }

            getTemplateName() {
                return `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28');

let template = env.loadTemplate('3483eac6e26600ce62238a645717078f3c5c8c6bdecca840762fe701fc51af28');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/media/demo/checkbox.twig", args: context }
     );
     return rendered;;
};